export default {"src":"/_next/static/media/Gol.919928e6.svg","height":42,"width":42};